module.exports = __webpack_public_path__ + "img/4.e27dfb27.jpg";